import { useAppStore } from '../../shared/store/store'
import styles from '../../styles.module.css'

export function AddPointOfViewButton() {
  const setPointsOfView = useAppStore((state) => state.setPointsOfView)
  const pointsOfView = useAppStore((state) => state.pointsOfView)

  const onClick = () => {
    setPointsOfView([...pointsOfView, { ...pointsOfView[0] }])
  }
  return (
    <button className={styles.add_point_of_interest_button} onClick={() => onClick()}>
      <p className={styles.add_point_of_interest_button_text}>+</p>
    </button>
  )
}
